import { LabelImportantOutlined, StarBorderOutlined } from '@mui/icons-material'
import { Checkbox, IconButton } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import {useNavigate} from 'react-router-dom'
import { selectMail } from '../features/counter/mailSlice'
import './EmailRow.css'
function EmailRow({title,subject,id,description,time}) {
    const history=useNavigate();
    const dispatch=useDispatch();
    const openMail=()=>{
      dispatch(selectMail({
        id,
        title,
        subject,
        description,
        time,
      }))
      history('/mail');
    }
  return (
    <div onClick={openMail} className='emailrow'>
      <div className="emailrow_option">
        <Checkbox/>
        <IconButton>
            <StarBorderOutlined/>
        </IconButton>
        <IconButton>
            <LabelImportantOutlined/>
        </IconButton>
        </div> 
      <div className="emailrow_title">
        <h3>{title}</h3></div> 
      <div className="emailrow_message">
        <h4>{subject}{''}
        <span className='emailrow_description'>{description}</span></h4></div> 
      
      <div className="emailrow_time">
        <p>{time}</p></div> 
    </div>
  )
}

export default EmailRow
